import { render, staticRenderFns } from "./qyEpidemic.vue?vue&type=template&id=68cf32a8&scoped=true&"
import script from "./qyEpidemic.vue?vue&type=script&lang=js&"
export * from "./qyEpidemic.vue?vue&type=script&lang=js&"
import style0 from "./qyEpidemic.vue?vue&type=style&index=0&id=68cf32a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cf32a8",
  null
  
)

export default component.exports